/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChatConversationSortCriteria {
    getFixupPrototypeFunction() { return ChatConversationSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ChatConversationSortCriteria>): ChatConversationSortCriteria {
        let obj = Object.assign(new ChatConversationSortCriteria(), model);
        ChatConversationSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChatConversationSortCriteria>): ChatConversationSortCriteria {
        if (!model) return null;
        return ChatConversationSortCriteria.newInstance(<ChatConversationSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChatConversationSortCriteria) {
        if (!obj) return;

        models.ChatConversationSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChatConversationSortCriteria): boolean {
        Object.setPrototypeOf(obj, ChatConversationSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ChatConversationSortColumn;

    ascending: boolean;

}
